<template>
    <!-- 플랫폼, 마이페이지 -->
    <div @mousedown="searchCloseHandler">
        <!-- protocol_search_top : S -->
        <div class="protocol_search_top">
            <div class="protocol_search_input_wrap">
                <platformSearch
                    :focusSearchInput               = "focusSearchInput"
                    :searchInputData                = "searchInputData"
                    :placeholder        = "'검색어를 입력하세요'"
                    @inputEnter         = "inputEnter"
                    @setSearchInputData = "(value) => {searchInputData  = value}"
                    @setFocusSearchInput= "(value) => {focusSearchInput = value}"
                    ref="protocolSearchList"
                />
            </div>
        </div>
        <!-- protocol_search_top : E -->
        <div class="ptc_container">
            <processDetail
                    :processDetailData="processDetailData"
                    v-if="processDetailActive === true"
                    :thisMyPage=false
                    :publishingActive="publishingActive"
                    @goToProtocolDetail="goToProtocolDetail"
                    @goToList="goToList"
            />
            <protocolDetail
                    :protocolDetailData="protocolDetailData"
                    v-if="processDetailActive === false"
                    :thisMyPage=false
                    :publishingActive="publishingActive"
                    @goToProcessDetail="goToProcessDetail(protocolDetailData.processId,0)"
                    @goToProtocolDetail="goToProtocolDetail"
                    @goToList="goToList"
            />
        </div>
        <Loading :visible="loading" type="fixed"></Loading>
        <!-- container : E -->
    </div>
</template>

<script>
    import {commNewMapMutations, commNewMapActions} from "@processEditor/CommNew";
    import MypageSubTitle from "@/views/Platform/Account/MypageSubTitle";
    import MypageWritingSubTitle from "@/views/Platform/Account/MypageWritingSubTitle";
    import processDetail from "@/components/platform_new/processDetail";
    import protocolDetail from "@/components/platform_new/protocolDetail";
    import {typeOfJson} from "@processEditor/CommNew";
    import platformSearch from "@common/platformSearch"
    import Loading from '@common/loading.vue'

    export default {
        components: {
            MypageSubTitle,
            MypageWritingSubTitle,
            processDetail,
            protocolDetail,
            platformSearch,
            Loading,
        },
        data() {
            return {
                loading: false,
                tabIndex: 0,
                viewMode: null,
                processDetailActive: null,
                processId: null,
                processDetailData: {},
                protocolId: null,
                protocolDetailData: {},
                searchInputData: "",
                publishingActive: true,
                focusSearchInput: false,
                selectSearchProcessType: "",
            };
        },
        computed: {},
        watch: {
            "$route.query": function(value) {
                this.searchInputData = this.$route?.query?.searchInputData;
                this.setOption(value);
                this.setData(this.$route.query?.tabIndex);
            },
        },
        async mounted() {
            this.searchInputData = this.$route?.query?.searchInputData;
            this.setOption();
            await this.getMe();
            this.setData(this.$route.query?.tabIndex);
        },
        methods: {
            ...commNewMapActions([
                'getProtocols',
            ]),
            ...commNewMapMutations([
                'setProcessId',
            ]),
            async getMe() {
                // 로그인 여부 확인.
                let userData = await await this.$wApi.user.mypage.me();
                if (userData == null || userData?.error) {
                    this.$router.push("/account/login");
                }
            },
            setOption() {
                if (this.$route.query?.protocolId) {
                    // 프로토콜 관련정보 setting
                    this.protocolId = this.$route.query?.protocolId;
                    this.viewMode = this.$route.query?.viewMode;
                    // 공정도 관련정보 및 이전에 존재할 수 있는 데이터 초기화
                    this.processDetailActive = null;
                    this.processId = null;
                    this.processDetailData = {};
                } else {
                    // 공정도 관련정보 setting
                    this.processId = this.$route.query?.processId;
                    // 프로토콜 관련정보 및 이전에 존재할 수 있는 데이터 초기화
                    this.processDetailActive = null;
                    this.protocolId = null;
                    this.viewMode = null;
                    this.protocolDetailData = {};
                }
            },
            async goToProcessDetail(processId, tabIndex) {
                this.$router.push({
                    path: this.$route.path,
                    query: {
                        processId: processId,
                        tabIndex: tabIndex,
                        searchInputData: this.searchInputData,
                    },
                });
            },
            async goToProtocolDetail(protocolId, viewMode, tabIndex, beforeProcessId) {
                this.$router.push({
                    path: this.$route.path,
                    query: {
                        protocolId: protocolId,
                        viewMode: viewMode,
                        tabIndex: tabIndex,
                        searchInputData: this.searchInputData,
                        beforeProcessId: beforeProcessId,
                    },
                });
            },
            async setData(n){
                this.selectSearchProcessType = n == 0 ? "NORMAL" : "ONLY_PROTOCOL";
                if (n == 0) {
                    //공정도 상세화면으로 사용.
                    this.loading = true;
                    try {
                        // 공정도 정보
                        this.processDetailData = await this.$wApi.process.release.detail(null, this.processId);
                        if(this.processDetailData.error){
                            throw this.processDetailData; 
                        }
                        this.processDetailData["userData"] = this.processDetailData["createdUser"];
                        this.processDetailData["json"] = this.processDetailData["content"];
                        this.processDetailData["protocols"] = await this.$wApi.process.release.getValidProtocols(null, this.processId);
                        this.processDetailActive = true;
                        this.loading = false;
                    }catch (e) {
                        this.loading = false;
                        window.alert(e.message);
                        this.$router.push("/account/login");
                    }finally {
                        this.loading = false;
                    }
                } else if (n == 1) {
                    try {
                        //프로토콜 상세 화면으로 사용.
                        this.loading = true;
                        let response = await this.$wApi.protocol.release.detail({protocolId: this.protocolId,});
                        if (response.error) {
                            throw response;
                        }
                        let nodeContents, issues;
                        let info = response;
                        if (response.nodeContent) nodeContents = JSON.parse(response.nodeContent);
                        issues = typeOfJson(info.content)
                        let shortValues = [];
                        for (let issue of issues.issues) {
                            delete issue.child;
                            if (nodeContents) {
                                if (issue.V === true && nodeContents[issue.key] && nodeContents[issue.key].replace(/(<([^>]+)>)/gi, '') != "") {
                                    shortValues.push({
                                        display: issue.display,
                                        isSelected: true,
                                        key: issue.key + '-shortValue',
                                        parent: issue.key,
                                        category: 'SHORTVALUE',
                                        visible: false,
                                        text: nodeContents[issue.key].replace(/(<([^>]+)>)/gi, '')
                                    })
                                }
                            }
                        }
                        if (shortValues.length > 0) issues.issues.push(...shortValues)
                        this.protocolDetailData = info;
                        this.protocolDetailData.json = issues;
                        this.protocolDetailData["userData"] = response["createdUser"];
                        this.protocolDetailData.viewType = this.viewMode;
                        this.protocolDetailData.isPublish = this.publishingActive ? 1 : 0
                        // component 렌더링. (v-else)
                        this.processDetailActive = false;
                        this.loading = false;
                    }catch (e) {
                        this.loading = false;
                        window.alert(e.message);
                        this.$router.push("/account/login")
                    }finally {
                        this.loading = false;
                    }
                }
            },
            goToList(){ 
                this.$router.push({
                    path: "/platform/search",
                    query: {
                        query: this.searchInputData,
                    }
                });
            },
            inputEnter(event) {
              this.searchInputData = event.target.value
              if(event.code === 'Enter' || event.keyCode === 13) {
                  this.$router.push({
                    path: '/platform/search',
                    query: {
                      query: this.searchInputData,
                    }
                  });
              }
            },
            searchCloseHandler(e) {
                let {$refs: {protocolSearchList}} = this;
                if (!protocolSearchList.$el.contains(e.target)) { //추천검색어 또는 input 영역이 아니면 추천 검색어 종료
                    this.focusSearchInput = false;
                }
            },
        }
    };
</script>
